'use strict';

import axios from 'axios';
import {handleError} from '@/_helpers/utils.js';

export default {
  namespaced: true,
  state () {
    return {
      groups: null,
      questions_2_groups: null,
      loaded: false,
      error: null
    }
  },
  actions: {
    load(context) {
      context.commit('set_loaded', false);
      context.commit('set_error', null);
      return Promise.all([
        axios.get(`/1.0/videointerview/${context.getters.vacancyId}/questions/groups`)
          .then(response => response.data.data)
          .then(data => {
            context.commit('set_groups', data);
          }),
        axios.get(`/1.0/videointerview/${context.getters.vacancyId}/questions/question2group`)
          .then(response => response.data.data)
          .then(data => {
            context.commit('set_questions_2_groups', data);
          })
      ])
        .then(() => {
          context.commit('set_loaded', true);
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_error', err);
          throw err;
        })
    },
    save(context) {
      return axios.put(
        `/1.0/videointerview/${context.getters.vacancyId}/questions/question2group`,
        context.getters['questions_2_groups']
      )
    },
    save_new_group(context, new_group) {
      return axios.post(
        `/1.0/videointerview/questions/group`,
        {
          vacancy_id: context.getters.vacancyId,
          name: new_group,
          order: context.getters.new_order,
        }
      )
        .then(response => response.data.data)
        .then(group => {
          context.commit('add_group', group);
        })
    },
    delete_group(context, id) {
      return axios.delete(
        `/1.0/videointerview/questions/group/${id}`,
      )
        .then(response => {
          context.commit('remove_group', id);
        })
    }
  },
  mutations: {
    set_groups (state, groups) {
      state.groups = groups;
    },
    add_group (state, group) {
      state.groups.push(group);
    },
    remove_group (state, id) {
      const pos = state.groups.findIndex(group => group.id === id);
      if (!~pos) return;
      state.groups.splice(pos, 1);
    },
    set_questions_2_groups (state, questions_2_groups) {
      state.questions_2_groups = questions_2_groups;
    },
    set_loaded (state, loaded) {
      state.loaded = loaded;
    },
    set_error (state, error) {
      state.error = error;
    },
    remove_connection (state, question_id) {
      const question_ids = state.questions_2_groups.map(connection => connection.question_id);
      const position = question_ids.indexOf(+question_id);
      if(~position) {
        state.questions_2_groups.splice(position, 1);
      }
    },
    add_connection (state, connection) {
      state.questions_2_groups.push(connection);
    }
  },
  getters: {
    question_label: () => {
      return `${window.$tr('videoInterview.questionCounter.question')} ${window.$tr('common.number')}`;
    },
    groups: (state) => state.groups,
    questions_2_groups: (state) => state.questions_2_groups,
    error: (state) => state.error,
    loaded: (state) => state.loaded,
    groups_fulled: (state, getters, rootState, rootGetters) => {
      const groups = [...state.groups];
      return groups.map(group => {
        group.questions = state.questions_2_groups
          .filter(connection => connection.group_id === group.id)
          .map(connection => rootGetters['vacancy/videointerview/get_question'](+connection.question_id));
        
        if (group.questions && group.questions.length > 0) {
          group.questions = group.questions.map((item, index) => {
            if (item && item.name) {
              let num = item.name.replace(/[^\d.]/g, '');
              return {...item, label:`${getters.question_label}${parseInt(num, 10)}`}
            }
            return item;
          });
        }
        console.log(group);
        return group;
      })
    },
    question_ids_with_group: (state) => state.questions_2_groups.map(connection => connection.question_id),
    questions_without_group: (state, getters, rootState, rootGetters) => {
      const question_ids_with_group = getters['question_ids_with_group'];
      let questions = rootGetters['vacancy/videointerview/questions'].map((item, index) => {
        if (item && item.name) {
          let num = item.name.replace(/[^\d.]/g, '');
          return {...item, label:`${getters.question_label}${parseInt(num, 10)}`}
        }
        return item;
      });
  
      let filtered_questions = questions.filter(question => {
        if (!question.id) {
          return false; // Если нет id, значит вопрос не сохранён и мы не можем назначить группу
        }
        return !~question_ids_with_group.indexOf(+question.id)
      });

      return filtered_questions;
    },
    new_order: (state) => {
      if (!state.groups.length) return 0;
      return Math.max.apply(null, state.groups.map(group => group.order)) + 1
    },
    vacancyId: (state, getters, rootState) => rootState.route.params.id,
  }
}